import * as types from './types';

export const initiateVacancyClose = (schoolId, vacancyId) => ({
  type: types.VACANCY_CLOSE_INITIATE,
  schoolId,
  vacancyId
});

export const cancelVacancyClose = () => ({
  type: types.VACANCY_CLOSE_CANCEL
});

export const getHiredApplications = (schoolId, vacancyId) => ({
  type: types.VACANCY_CLOSE_GET_HIRED_APPLICATIONS,
  schoolId,
  vacancyId
});

export const setHiredApplications = (applications) => ({
  type: types.VACANCY_CLOSE_SET_HIRED_APPLICATIONS,
  applications
});

export const setHiredApplicationsLoading = (isLoading) => ({
  type: types.VACANCY_CLOSE_SET_HIRED_APPLICATIONS_LOADING,
  isLoading
});

export const getActiveApplicationsCount = (schoolId, vacancyId) => ({
  type: types.VACANCY_CLOSE_GET_ACTIVE_APPLICATIONS_COUNT,
  schoolId,
  vacancyId
});

export const setActiveApplicationsCount = (applicationsCount) => ({
  type: types.VACANCY_CLOSE_SET_ACTIVE_APPLICATIONS_COUNT,
  applicationsCount
});

export const setActiveApplicationsCountLoading = (isLoading) => ({
  type: types.VACANCY_CLOSE_SET_ACTIVE_APPLICATIONS_COUNT_LOADING,
  isLoading
});

export const closeVacancy = (schoolId, vacancyId, notFilledOpeningsCount, filledNotViaApliOpeningsCount) => ({
  type: types.VACANCY_CLOSE_RUN,
  schoolId,
  vacancyId,
  notFilledOpeningsCount,
  filledNotViaApliOpeningsCount
});

export const setVacancyClosing = (isClosing) => ({
  type: types.VACANCY_CLOSE_SET_CLOSING,
  isClosing
});

export const setVacancySuggestedToClose = (schoolId, vacancyId) => ({
  type: types.VACANCY_CLOSE_SET_SUGGESTED_VACANCY,
  schoolId,
  vacancyId
});

export const resetVacancySuggestedToClose = () => ({
  type: types.VACANCY_CLOSE_RESET_SUGGESTED_VACANCY
});



// WEBPACK FOOTER //
// ./src/actions/vacancy-close/index.js